import { useModalStore } from '../../store/modalStore';
import { useToastStore } from '../../store/toastStore';
import { useDeleteVideo } from '../../hooks/useVideos';
import type { Video } from '../../types/models';

export function DeleteVideoModal() {
  const { isOpen, modalType, modalData, closeModal } = useModalStore();
  const addToast = useToastStore((state) => state.addToast);
  const deleteMutation = useDeleteVideo();

  const video = modalData as Video;
  const open = isOpen && modalType === 'deleteVideo' && !!video;

  if (!open) return null;

  const deleting = deleteMutation.isPending;

  const handleDelete = async () => {
    try {
      await deleteMutation.mutateAsync(video.id);
      addToast('Video deleted', 'success');
      closeModal();
    } catch (err) {
      addToast((err as Error).message || 'Failed to delete video', 'error');
    }
  };

  return (
    <div className="modal-overlay" onClick={closeModal}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Delete Video</h2>
          <button onClick={closeModal} className="btn-close" type="button">
            ×
          </button>
        </div>

        <div className="modal-body">
          <p>
            Are you sure you want to delete <strong>{video.title}</strong>?
          </p>
          <p className="warning">This action cannot be undone.</p>
        </div>

        <div className="modal-footer">
          <button onClick={closeModal} className="btn btn-secondary" type="button">
            Cancel
          </button>
          <button
            onClick={() => void handleDelete()}
            className="btn btn-danger"
            disabled={deleting}
            type="button"
          >
            {deleting ? 'Deleting...' : 'Delete Video'}
          </button>
        </div>
      </div>
    </div>
  );
}
